





























import { Component, Vue, Prop } from "vue-property-decorator";
@Component({
    components: {},
})
export default class EmployeeStandByAndUrgentCallnfo extends Vue {
    @Prop({ required: true }) line;
}
